import {
  Exact,
  GqlListBankAccountsQuery,
  GqlMxBankAccount,
  StatusTypes,
  useListBankAccountsQuery,
} from 'types/graphql';

import useStores from 'shared/hooks/use-stores';
import { ApolloQueryResult } from 'apollo-client';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { Nullish } from 'shared/utils/type-utils';

type UseBankAccountsUtils = {
  bankAccounts: (Pick<
    GqlMxBankAccount,
    'accountAlias' | 'bankName' | 'billingAddressId' | 'entityId' | 'id' | 'lastDigits' | 'status'
  > & { _typename?: 'MxBankAccount' | undefined })[];
  connectionStatus: Nullish | string;
  mxWidgetUrl: Nullish | string;
  billingAddressId: Nullish | string;
  loading: boolean;
  statusAggregatorError: boolean;
  refetchBankAccountData: (
    variables?: Exact<{ aggregator: string }> | undefined
  ) => Promise<ApolloQueryResult<GqlListBankAccountsQuery>>;
};

export const useListBankAccounts = ({ skip = false }): UseBankAccountsUtils => {
  const { User } = useStores();
  const DutchiePayEnrollment = useDutchiePayEnrollment();

  const { data, refetch, loading } = useListBankAccountsQuery({
    variables: { aggregator: DutchiePayEnrollment.aggregator },
    skip: (!User.exists && !User.hasExternalUser) || skip,
  });

  const bankAccounts = data?.listBankAccounts?.bankAccounts ?? [];
  const connectionStatus = bankAccounts[0]?.mx?.connectionStatus;
  const mxWidgetUrl = bankAccounts[0]?.mx?.widgetUrl;
  const billingAddressId = bankAccounts[0]?.billingAddressId;
  const statusAggregatorError = bankAccounts[0]?.status === StatusTypes.statusAggregatorError;
  const refetchBankAccountData = refetch;

  return {
    bankAccounts,
    connectionStatus,
    mxWidgetUrl,
    billingAddressId,
    statusAggregatorError,
    refetchBankAccountData,
    loading,
  };
};
